import Login from '@/components/Login/Login'
import Inicio from'@/components/Inicio'
import Cadastro from'@/components/Cadastro'
import Debitos from '@/components/Debitos'
import Acordos from '@/components/Acordos'
import DocumentosMenu from '@/components/DocsMenu'
import Rotas from '@/components/Rotas'
export default [
        {
            path:'/',
            name: 'login',
            component: Login
            // component: () => import(/* webpackChunkName: "Login" */ '@/components/Login/Login')
        },
        {
            path:'/inicio',
            name: 'inicio',
            component: Inicio
            // component: () => import(/* webpackChunkName: "Inicio" */ '@/components/Inicio')
        },
        {
            path:'/cadastro',
            name: 'cadastro',
            component: Cadastro
            // component: () => import(/* webpackChunkName: "Cadastro" */ '@/components/Cadastro')
        },
        {
            path:'/debitos',
            name: 'debitos',
            component: Debitos
            // component: () => import(/* webpackChunkName: "Debitos" */ '@/components/Debitos')
        },
        {
            path:'/acordos',
            name: 'acordos',
            component: Acordos
            // component: () => import(/* webpackChunkName: "Acordos" */ '@/components/Acordos')
        },
        {
            path: '/documentos/:doc',
            name: 'documentosMenu',
            component: DocumentosMenu
        },
        {
            path:'/:destino',
            name: 'rotas',
            component: Rotas
            // component: () => import(/* webpackChunkName: "Rotas" */ '@/components/Rotas')
        }
]